<template>
    <form>
        <div class="flex -mx-1 mb-4">
            <div class="form-group w-full px-1">
                <label for="title" class="form-label">Title</label>
                <input type="text" v-model="form.title" placeholder="Title" class="form-control" id="title" @keydown.enter="onSubmit">
            </div>

            <div class="form-group w-full px-1">
                <label for="image" class="form-label">Image</label>
                <div class="form-control form-file-control">
                    <label for="image">
                        <span>{{ selectedImage }}</span>
                    </label>
                    <input type="file" ref="image" id="image" @change="onChangeImageUpload()" />
                </div>
            </div>
        </div>

        <div class="preview w-full mt-1" v-if="imageData">
            <div class="preview-item flex flex-wrap w-full p-1">
                <figure class="preview-cover" :style="`background-image: url(${imageData})`"></figure>
            </div>
        </div>

        <div class="flex -mx-1 mb-4">
            <div class="form-group w-full px-1">
                <label for="body" class="form-label">Body</label>
                <!-- <editor v-model="form.body" :init="this.settings" id="body" /> -->
            </div>
        </div>

        <hr>

        <!-- TODO: Partial component with onSubmit code and route as prop -->
        <div class="buttons d-flex justify-content-end">
            <transition name="fade">
                <div class="is-processing" v-show="isProcessing">
                    <loading class="mr-2"></loading>
                </div>
            </transition>
            <button type="button" class="btn btn-lg btn-success" @click="onSubmit" :disabled="isProcessing">
                <span v-html="_btnValue"></span>
            </button>
        </div>
    </form>
</template>

<script>
import Loading from '../Loading'
import Form from '../../core/Form'
// TODO: use the one in the layout not this one.

export default {
    props: {
        post: {
            type: Object,
            default: null,
        },
    },

    components: {
        Loading,
    },

    data() {
        return {
            isProcessing: false,
            resetData: false,
            form: new Form({
                title: '',
                body: '',
                image: '',
            }),
            imageData: '',
            settings: {
                menubar: false,
                menu: [],
                plugins: ['lists fullscreen paste wordcount'],
                toolbar: 'undo redo | bold | bullist numlist',
                relative_urls: false,
                paste_as_text: true,
                min_height: 300,
            },
        }
    },

    created() {
        if (this.post !== null) {
            this.form.title = this.post.title
            this.form.body = this.post.body
            this.imageData = this.post.images.hero
        }
    },

    computed: {
        _route() {
            return this.post === null
                ? {
                    name: route('admin.posts.store'),
                    request: 'postWithFile',
                }
                : {
                    name: route('admin.posts.update', this.post.id),
                    request: 'patchWithFile',
                }
        },

        selectedImage() {
            return this.form.image ? this.form.image.name : "Choose an image...";
        },

        _btnValue() {
            return this.post === null
                ? 'Create Post'
                : 'Update Post'
        }
    },

    methods: {
        onChangeImageUpload() {
            this.form.image = this.$refs.image.files[0];

            console.log(this.form.image);

            this.imageData = URL.createObjectURL(this.form.image);
        },

        onSubmit() {
            this.isProcessing = true

            this.form[this._route.request](this._route.name)
                .then(response => {
                    Bus.$emit('onSuccess', response)

                    this.imageData = '';

                    this.isProcessing = false
                })
                .catch(error => {
                    Bus.$emit('onFailure', error)

                    this.isProcessing = false
                })
        },

        getImageURL(img) {
            let url = URL.createObjectURL(img);

            return `background-image: url(${url})`;
        },
    }
}
</script>
